/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AppointmentRequestVariantId } from './AppointmentRequestVariantId';
import {
    AppointmentRequestVariantIdFromJSON,
    AppointmentRequestVariantIdFromJSONTyped,
    AppointmentRequestVariantIdToJSON,
    AppointmentRequestVariantIdToJSONTyped,
} from './AppointmentRequestVariantId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateTimeEntryRequest
 */
export interface CreateTimeEntryRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateTimeEntryRequest
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof CreateTimeEntryRequest
     */
    entryDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    clockIn: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    clockOut: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateTimeEntryRequest
     */
    timeEntryTypeId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof CreateTimeEntryRequest
     */
    appointmentId: AppointmentRequestVariantId | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    remarks: string | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof CreateTimeEntryRequest
     */
    appointmentBookingId?: AppointmentRequestVariantId | null;
}

/**
 * Check if a given object implements the CreateTimeEntryRequest interface.
 */
export function instanceOfCreateTimeEntryRequest(value: object): value is CreateTimeEntryRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('entryDate' in value) || value['entryDate'] === undefined) return false;
    if (!('clockIn' in value) || value['clockIn'] === undefined) return false;
    if (!('clockOut' in value) || value['clockOut'] === undefined) return false;
    if (!('timeEntryTypeId' in value) || value['timeEntryTypeId'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function CreateTimeEntryRequestFromJSON(json: any): CreateTimeEntryRequest {
    return CreateTimeEntryRequestFromJSONTyped(json, false);
}

export function CreateTimeEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTimeEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'entryDate': (new Date(json['entryDate'])),
        'clockIn': json['clockIn'],
        'clockOut': json['clockOut'],
        'timeEntryTypeId': ActorActivityRecordActorUserIdFromJSON(json['timeEntryTypeId']),
        'appointmentId': AppointmentRequestVariantIdFromJSON(json['appointmentId']),
        'remarks': json['remarks'],
        'appointmentBookingId': json['appointmentBookingId'] == null ? undefined : AppointmentRequestVariantIdFromJSON(json['appointmentBookingId']),
    };
}

export function CreateTimeEntryRequestToJSON(json: any): CreateTimeEntryRequest {
    return CreateTimeEntryRequestToJSONTyped(json, false);
}

export function CreateTimeEntryRequestToJSONTyped(value?: CreateTimeEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'entryDate': value['entryDate'].toISOString().substring(0,10),
        'clockIn': value['clockIn'],
        'clockOut': value['clockOut'],
        'timeEntryTypeId': ActorActivityRecordActorUserIdToJSON(value['timeEntryTypeId']),
        'appointmentId': AppointmentRequestVariantIdToJSON(value['appointmentId']),
        'remarks': value['remarks'],
        'appointmentBookingId': AppointmentRequestVariantIdToJSON(value['appointmentBookingId']),
    };
}

